import React, { useRef, useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useHistory } from "react-router";
import ListComponent from "./ListComponent";
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, fetchDeletePromisedData, getDropdownIdsFromSelectArray, updateRequestLabels } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import IconButtonWrapper from "../../../../../views/pages/manage/common/form-fields-mui/IconButtonWrapper";

const RefundApprovalLogs = () => {
    const history = useHistory();
    const [loader, setLoader] = useState(false);
    const [rows, setRows] = useState([]);

    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(50);

    const fetchLogs = async (pageNumber = 0, pageSize = currPageSize) => {
        try {
            setLoader(true);
            const resp = await fetchAllPromisedData(`${endpoint?.refund?.approvalConfig?.logs}?offset=${pageNumber}`, true);
            if (resp?.code == 200) {
                const updatedData = Array?.isArray(resp?.data?.paginatedData) ? resp?.data?.paginatedData?.map((item, index) => {
                    return {
                        ...item,
                        id: index
                    }
                }) : []
                setCurrentPageSize(pageSize);
                setRows(updatedData);
                setPaginationInfo({
                    currentPage: resp?.data?.currentPage,
                    totalPage: resp?.data?.totalPage,
                    totalRecords: resp?.data?.totalRecords,
                });
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    };

    const nextButtonHandler = (newPage, currPageSize) => {
        fetchLogs(newPage, currPageSize);
    };

    useEffect(() => {
        fetchLogs()
    }, [])

    return (
        <>
            <Card className="mx-2">
                <div className="d-flex justify-content-between my-3 mx-2">
                    <div className="d-flex justify-content-between">
                        <IconButtonWrapper onClick={() => window.close()}>
                            <BackArrow />
                        </IconButtonWrapper>
                        <h4 style={{marginTop:"11%"}} className="color-black">Logs</h4>
                    </div>
                    {/* <div className="d-flex justify-content-between">
                        <AButton
                            variant="primary_filled"
                            onClick={() => ref.current.addNewRow()}
                            size="xs"
                        >
                            + Add configuration
                        </AButton>
                    </div> */}
                </div>

                <ListComponent
                    loader={loader}
                    currentPage={paginationInfo?.currentPage}
                    currPageSize={currPageSize}
                    rows={rows}
                    nextButtonHandler={nextButtonHandler}
                    rowCount={paginationInfo.totalRecords}
                />
            </Card>
        </>
    )
}

export default RefundApprovalLogs;